import { withSvgIcon } from './withSvgIcon';

export const CoinStack = withSvgIcon(
  <>
    <ellipse
      cx="7.5"
      cy="6.75"
      rx="4.5"
      ry="2.25"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinejoin="round"
    />
    <path
      d="M12 6.75C12 7.99264 9.98528 9 7.5 9C5.01472 9 3 7.99264 3 6.75"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinejoin="round"
    />
    <path
      d="M12 13.75C12 14.9926 9.98528 16 7.5 16C5.01472 16 3 14.9926 3 13.75"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinejoin="round"
    />
    <path
      d="M12 10.25C12 11.4926 9.98528 12.5 7.5 12.5C5.01472 12.5 3 11.4926 3 10.25"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinejoin="round"
    />
    <path
      d="M21 13.75C21 14.9926 18.9853 16 16.5 16C14.0147 16 12 14.9926 12 13.75"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinejoin="round"
    />
    <ellipse
      cx="16.5"
      cy="10.25"
      rx="4.5"
      ry="2.25"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinejoin="round"
    />
    <path
      d="M12 6.75V17.25C12 18.4926 9.98528 19.5 7.5 19.5C5.01472 19.5 3 18.4926 3 17.25V6.75"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinejoin="round"
    />
    <path
      d="M21 10.25V17.25C21 18.4926 18.9853 19.5 16.5 19.5C14.0147 19.5 12 18.4926 12 17.25V10.25"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
